module.exports = __webpack_public_path__ + "img/header-weddingRingsFacetes.a3b81ff.jpg";